export default __webpack_public_path__ + "static/beira-mar-8cbe6856788051cad362e5f136642fa9.jpg";